import { useSuspenseQuery } from '@tanstack/react-query'

import { type UserRole } from '@/libs/api/types'

import { getAvailableDcsSelectQueryOptions } from '../query-options'

/**
 * 利用可能拠点一覧を利用するためのHook
 */
export const useAvailableDcs = (
  tenantKey: string,
  user: { id: number; userRole: UserRole }
) => {
  return useSuspenseQuery({
    ...getAvailableDcsSelectQueryOptions(tenantKey, user),
    retry: false
  })
}
